import axios from "axios";
import { OrganizationURL } from "../../../config/UrlEndPoint";

export const URL = `${OrganizationURL}organization`;

// Find Plan Usage Log
export function findPlanUsageLog(queryParams) {
  return axios.post(`${URL}/plan_usage_log/find`, queryParams);
}
